import React, { useEffect, useRef } from 'react';
import { Form } from 'antd';
import s from './s.module.less';
import LicenseUploadForm from 'components/PPAOnboarding/LicenseUploadForm';
import { License } from 'types/common';

interface IProps {
    formId?: string;
    onSaveStep: () => void;
    initValue?: License[] | null;
    setNextButtonDisabled: (disabled: boolean) => void;
}

// Wrapper component to make FileUploadPrivate work with Form.Item

const Step4 = ({
    formId,
    onSaveStep,
    initValue,
    setNextButtonDisabled,
}: IProps) => {
    const [form] = Form.useForm();
    const licenseUploadFormRef = useRef<any>(null);
    const isSubmittingRef = useRef(false);

    const onFinish = async () => {
        try {
            isSubmittingRef.current = true;
            const canSkip = await licenseUploadFormRef.current?.onUpdate();
            // 如果返回 true，说明没有填写内容，可以跳过，直接调用 onSaveStep
            if (canSkip) {
                isSubmittingRef.current = false;
                onSaveStep?.();
            }
            // 如果返回 false 或 undefined，说明已经提交数据，handleSuccess 会处理
        } catch (error) {
            // 验证失败时，不提交数据
            isSubmittingRef.current = false;
        }
    };

    useEffect(() => {
        setNextButtonDisabled(false);
    }, [setNextButtonDisabled]);

    const handleSuccess = () => {
        // 只有在表单提交过程中才调用 onSaveStep
        if (isSubmittingRef.current) {
            isSubmittingRef.current = false;
            onSaveStep?.();
        }
    };

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                {/* Header Section */}
                <div className={s.header}>
                    <h1>Upload your medical license</h1>
                    <div className={s.headerDescription}>This helps us confirm your credentials and the states you serve.</div>
                </div>

                {/* Form Section */}
                <Form
                    id={formId}
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <LicenseUploadForm
                        ref={licenseUploadFormRef}
                        onSuccess={handleSuccess}
                        value={initValue}
                        required
                    />
                </Form>
            </div>
        </div>
    );
};

export default Step4;
